import { Product } from '../../../modules/product/models/Product'
import {
  emptyPatientMatchingDTO,
  fromPatientMatchingModel,
  PatientMatchingDTO,
  toModelPatientMatching,
} from '../../../modules/patient/models/patientForm/PatientMatchingDTO'
import { useEffect, useState } from 'react'
import { useStyles } from '../Application.styles'
import { COLOR_PRIMARY } from '../../../routes/color-constants'
import { useTranslation } from 'react-i18next'
import { PatientMatching } from '../../../modules/patient/models/patientForm/PatientMatching'
import { Button, FormControl, Grid, InputLabel, MenuItem, Select, TextField, FormControlLabel, FormGroup, Checkbox, FormLabel, RadioGroup, Radio, Typography } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2'
import { FormType, userGenders } from '../../../common/enums/Enums'
import { getPatientContainer } from 'container/patient-modules'
import { getClientContainer } from 'container/client-modules'
import { PatientService } from 'modules/patient/services/PatientService'
import { ClientService } from 'modules/clients/services/ClientService'
import { PATIENT_SERVICE_KEY } from 'modules/patient'
import { CLIENTS_SERVICE_KEY } from 'modules/clients'
import { Query, QueryParam } from 'common/api/Query'
import { emptySampleMatchingDTO, toModel } from 'modules/sampleType/models/sampleForm/SampleMatchingDTO'
import { emptySampleDTO } from 'modules/sample/models/SampleDTO'
import { v4 as uuidv4 } from 'uuid'
import {  isValid } from 'date-fns'
import {convertTimeToLocal, formatDate } from '../../../common/utils/DataFormatters'

type RouteProps = {
  id?: string
  navigate?: () => void
}

export type FormMatchingProps = RouteProps & {
  patients: PatientMatchingDTO[]
  productIndex: number
  handleChangePatients: (productIndex: number, patients: any[], type: FormType) => void
  product: Product
  type?: string
  edit?: boolean
  clientIDDoingTheRequest: string
  setIsOpen: (bool: boolean) => void
  setCurrentProduct: (curentProduct: number) => void
  setCurentType: (curentType: number) => void
  setMatchingBlind: (value: boolean) => void
  updatePanelSelection: (value: string, index: number) => void
  matchingBlind: boolean
  panelSelections: string[]
}

const patientService = getPatientContainer().get<PatientService>(PATIENT_SERVICE_KEY)
const clientService = getClientContainer().get<ClientService>(CLIENTS_SERVICE_KEY)

export const PatientFormMatching = (props: FormMatchingProps) => {
  const patientNumber = 2
  const classes = useStyles({ color: COLOR_PRIMARY })
  const [patients, setPatients] = useState<PatientMatchingDTO[]>(props.patients || [])
  const { t, i18n } = useTranslation()
  const [selectedPatientID, setSelectedPatientID] = useState<string[]>([])
  const [previousPatients, setPreviousPatients] = useState<PatientMatching[]>([])
  const [checkedBlindMatching, setCheckedBlindMatching] = useState<boolean>(false)
  const [panelsSelected, setPanelsSelected] = useState(["0", "0"]);
  const [external,setExternal] = useState<boolean>(false)

  useEffect(()=>{
    if (props.patients) {
      const auxPatients = Object.fromEntries(Object.entries(props.patients).map(([k, v]) => [k.startsWith('_') ? k : `_${k}`, v]));
      setPatients(Object.values(auxPatients))
    }
  },[props.patients])

  useEffect(() => {
    if (patients.length >= 2) {
      setPanelsSelected([
        String(patients[0]._panelSelected) || "0",
        String(patients[1]._panelSelected) || "0"
      ]);
    }
  }, [patients]);

  useEffect(() => {
    let patientsAux: PatientMatchingDTO[] = []
    let start = 0

    for (let i = start; i < patientNumber; i++) {
      if (props.patients?.length >= i && props.patients[i]) {
        let filtered = previousPatients.filter((p) => p.id == props.patients[i]._id)
        let auxSelected: any[] = []

        if (filtered?.length > 0) {
          if (patientNumber > 0) {
            auxSelected[0] = filtered[0].id
            patientsAux[0] = fromPatientMatchingModel(filtered[0])
          }

          setSelectedPatientID(auxSelected)
        }
        patientsAux[i] = props.patients[i]
      } else {
        patientsAux[i] = emptyPatientMatchingDTO()
      }
    }

    setPatients(patientsAux)
  }, [previousPatients])

  useEffect(() => {
    if (props.patients?.length > 0) {
      let auxSelected: any[] = []
      props.patients.forEach((p, i) => {
        auxSelected[i] = p._id
      })
      setSelectedPatientID(auxSelected)
    } else {
      let auxSelected: any[] = []
      Array(patientNumber).forEach((_, i) => {
        auxSelected[i] = ''
      })
      setSelectedPatientID(auxSelected)
    }
  }, [])

  useEffect(() => {
    clientService.getByID(props.clientIDDoingTheRequest).subscribe(async (res) => {
      if (res) {
        let client = res

    let all = await patientService.getAllPatients(  new Query({
                  query: [new QueryParam('clientID', client.id || '')],
                })).toPromise()
      const resultArray = [...(all?.items) || []]
        let personasFiltradas: any[] = filtrarPersonas(resultArray)

        if (window.location.pathname.includes('new')) {
          personasFiltradas.forEach((persona) => {
            //@ts-ignore
            persona._sample = toModel(emptySampleDTO())
            //@ts-ignore
            persona.sample = toModel(emptySampleDTO())
          })
        }

        setPreviousPatients(personasFiltradas)
      }
    })
  }, [])

  function setPanelSelected(value: string, index: number) {
    console.log("____setPanelSelected_______")
    const newArray = [...panelsSelected];
    newArray[index] = value;
    setPanelsSelected(newArray);
    props.updatePanelSelection(value, index);
    patients[index]._panelSelected = +value;
    console.log("patient cambiado", patients[index])
  }
  

  function filtrarPersonas(personas: any[]): any[] {
    const personasFiltradas: { [key: string]: any } = {}

    personas.forEach((persona) => {
      if (personasFiltradas[persona.firstName + persona.lastName]) {
        if (persona.priority) {
          personasFiltradas[persona.firstName + persona.lastName] = persona
        }
      } else {
        personasFiltradas[persona.firstName + persona.lastName] = persona
      }
    })

    return Object.values(personasFiltradas)
  }

  const getEmptyPatients = (): PatientMatchingDTO[] => {
    const patients: PatientMatchingDTO[] = []
    if (patientNumber) {
      for (let i = 0; i < patientNumber; i++) {
        patients.push(emptyPatientMatchingDTO())
      }
    }
    return patients
  }

  useEffect(() => {
    if (
      props.type != 'view' &&
      ((props.patients !== null && props.patients?.length == 0) || props.patients == null)
    ) {
      props.handleChangePatients(props.productIndex, getEmptyPatients(), FormType.TypeFormMatching)
    }
  }, [])

  useEffect(() => {
    if (props.type == 'view') {
      props.handleChangePatients(props.productIndex, props.patients, FormType.TypeFormMatching)
    }
  }, [])

  useEffect(() => {
    if (props.type == 'view') {
      props.handleChangePatients(props.productIndex, props.patients, FormType.TypeFormMatching)
    }
  }, [props.type])

  const handlePatientChange = (
    index: number,
    field: keyof PatientMatching,
    value: string | Date | boolean | number
  ) => {
    if(field === "_external") debugger
    const newPatients = [...patients]
    const patientToUpdate = newPatients[index]
    const updatedPatient = { ...patientToUpdate, [field]: value }

    if (!updatedPatient._id) {
      updatedPatient._id = uuidv4()
    }

    newPatients[index] = updatedPatient
    setPatients(newPatients)
    props.handleChangePatients(props.productIndex, newPatients, FormType.TypeFormMatching)
  }

  const handleSetSelectedValue = (index: number, value: string) => {
    let patientsAux = previousPatients.filter((p) => p.id === value)
    let newPatients = [...patients]

    if (patientsAux?.length > 0) {
      let patient = patientsAux[0]

      let auxElement = {
        _id: patient.id,
        _firstName: patient.firstName,
        _lastName: patient.lastName,
        _dob: patient.dob,
        _nhcOrDni: patient._nhcOrDni,
        _province: patient.province,
        _zipCode: patient.zipCode,
        _phone: patient.phone,
        _email: patient.email,
        _indication: patient.indication,
        _clinicHistory: patient.clinicHistory,
        _sex: patient.sex,
        _genes: patient.genes,
        _panelSelected: patient.panelSelected,
        _sample: patient._sample ? patient._sample : toModel(emptySampleMatchingDTO()),
        _bioarrayCode: patient._bioarrayCode, 
        _external: patient._external
      }

      newPatients.splice(index, 1, auxElement)
    } else {
      newPatients.splice(index, 1, toModelPatientMatching(emptyPatientMatchingDTO()))
    }

    setPatients(newPatients)
    props.handleChangePatients(props.productIndex, newPatients, FormType.TypeFormMatching)

    let auxSelected = [...selectedPatientID]
    auxSelected[index] = value
    setSelectedPatientID(auxSelected)
  }

  const openModal = () => {
    props.setCurrentProduct(props.productIndex)
    props.setCurentType(FormType.TypeFormMatching)
    props.setIsOpen(true)
  }

  return (
    <Grid container direction="column">

    <FormControlLabel
      control={
        <Checkbox
          checked={checkedBlindMatching}
          onClick={() => {
            const newVal = !checkedBlindMatching;
            setCheckedBlindMatching(newVal)
            props.setMatchingBlind?.(newVal)
          }}
        />
      }
      label={t('blindMatching')}
    />

      {[...Array(patientNumber)].map((_, index) => (
        <Grid container spacing={4} key={index} style={{ marginTop: '40px' }}>
          <Grid item xs={12} style={{ textAlign: 'left', fontWeight: 'bold', fontSize: '18px' }}>
          {t('fillPatientData') + ' ' + (index + 1) + ' ' + t('for') + ' ' + (i18n.language == "es" ? props.product.nameES : props.product.nameEN)}
          </Grid>
          {props.edit !== false && (
            <Grid item xs={12}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel id="typeSampleLabel">{t('selectPatient')}</InputLabel>
                <Select
                  labelId={'typeSampleLabel'}
                  id={'type'}
                  name={'type'}
                  //@ts-ignore
                  onChange={(e) => handleSetSelectedValue(index, e.target.value)}
                  style={{ width: '50%' }}
                  value={selectedPatientID?.length > index ? selectedPatientID[index] : ''}>
                  {previousPatients.map((patient, indexST) => {
                    return (
                      <MenuItem key={indexST} value={patient.id}>
                        {patient.firstName + ' ' + patient.lastName}
                      </MenuItem>
                    )
                  })}
                  <MenuItem key={''} value={''}>
                    {t('notSelect')}
                  </MenuItem>
                </Select>

                {props.productIndex > 0 && (
                <Button
                  variant="contained"
                  onClick={openModal}
                  className={classes.button}
                  style={{ display: 'flex', alignSelf: 'flex-end' }}>
                  {t("aplyPatientes")}
                </Button>)
               }

              </FormControl>

            </Grid>
          )}
          <Grid item xs={6}>
            <TextField
              id={`firstName-${index}`}
              label={t('name')}
              variant="filled"
              disabled={props.edit === false}
              fullWidth
              className={classes.textField}
              value={(patients && patients[index]?._firstName) || ''}
              onChange={(e) => handlePatientChange(index, '_firstName', e.target.value)}
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`lastName-${index}`}
              label={t('lastName')}
              disabled={props.edit === false}
              variant="filled"
              fullWidth
              className={classes.textField}
              value={(patients && patients[index]?._lastName) || ''}
              onChange={(e) => handlePatientChange(index, '_lastName', e.target.value)}
              required={true}
            />
          </Grid>
          <Grid item xs={6}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                format="dd/MM/yyyy"
                value={(patients && convertTimeToLocal(patients[index]?._dob) )|| null}
                onChange={(date) => date && isValid(date) && handlePatientChange(index, '_dob', formatDate(date))}
                label={t('dob')}
                disabled={props.edit === false}
                slotProps={{
                  textField: {
                    variant: 'outlined',
                    size: 'small',
                    required: true,
                    sx: { width: '100%' },
                    id: `dob-${index}`,
                  }
                }}
              />
            </LocalizationProvider>
            {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                defaultValue={new Date()}
                disabled={props.edit === false}
                format="dd/MM/yyyy"
                value={(patients && patients[index]?._dob) || null}
                onChange={(date) => date && handlePatientChange(index, '_dob', new Date(date))}
     
                label={t('dob')}
              />
            </LocalizationProvider> */}
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`nhcOrDni-${index}`}
              disabled={props.edit === false}
              label={t('nhc')}
              variant="filled"
              fullWidth
              className={classes.textField}
              value={(patients && patients[index]?._nhcOrDni) || ''}
              onChange={(e) => handlePatientChange(index, '_nhcOrDni', e.target.value)}
              required
            />
          </Grid>
          <Grid item xs={6}>
          <TextField
              id={`bioarrayCode-${index}`}
              disabled={props.edit === false}
              label={t('bioarrayCode') + (index === 1 && external?  "" : " *")}
              variant="filled"
              fullWidth
              className={classes.textField}
              value={(patients && patients[index]?._bioarrayCode) || ''}
              onChange={(e) => handlePatientChange(index, '_bioarrayCode', e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth variant="outlined">
              <InputLabel id="inherit-label">{t('gender') + '*'}</InputLabel>
              <Select
                labelId="gender-label"
                id="gender"
                fullWidth={props.edit === false}
                style={{ textAlign: 'left' }}
                value={(patients && patients[index]?._sex) || ''}
                onChange={(e) => handlePatientChange(index, '_sex', e.target.value as string)}
                required
                label={t('gender')}>
                {Object.entries(userGenders())?.map(([key, value]) => (
                  <MenuItem value={key}>{value}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
         {index === 1 && (
          <Grid item xs={12} 
            style={{textAlign: 'left'}}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={external}
                  onClick={() => {
                    handlePatientChange(index, '_external', !external)
                    setExternal(!external)
                  }}
                />
              }
              label={t('externalInform')}
            />
            <Grid>{t('externalDisclaimer')}</Grid>
          </Grid>
        )}
          <Grid item xs={12}>

            <FormControl>
              <FormLabel id="radio-genes-panel">{t('desiredGenes')}</FormLabel>
              <RadioGroup
                aria-labelledby="radio-genes-panel"
                name="radio-genes-panel"
                value={panelsSelected[index]}
                onChange={(e) => setPanelSelected(e.target.value, index)}
              >
                <FormControlLabel value="0" disabled={checkedBlindMatching} control={<Radio />} label={t('panelFull')} />
                <FormControlLabel value="1" disabled={checkedBlindMatching} control={<Radio />} label={t('panelSpecific')} />
                <Typography 
                  variant="caption" 
                  component="span"
                  className = {checkedBlindMatching ? "Mui-disabled MuiFormControlLabel-label" : ""}>
                    {t('panelSpecificDisclaimer')}
                </Typography>
                <FormControlLabel value="2" disabled={checkedBlindMatching} control={<Radio />} label={t('panelNone')} />
              </RadioGroup>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            {panelsSelected[index] == "1" && !checkedBlindMatching &&
              <TextField
                fullWidth
                id={`genes-${index}`}
                disabled={props.edit === false}
                label={t('genesPanel')}
                onChange={(event) => handlePatientChange(index, '_genes', event.target.value)}
                multiline
                rows={2}
                value={(patients && patients[index]?._genes) || ''}
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            }
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              id={`indication-${index}`}
              disabled={props.edit === false}
              label={t('indication')}
              onChange={(event) => handlePatientChange(index, '_indication', event.target.value)}
              multiline
              rows={4}
              value={(patients && patients[index]?._indication) || ''}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              id={`clinicHistory-${index}`}
              disabled={props.edit === false}
              label={t('clinicHistory')}
              onChange={(event) => handlePatientChange(index, '_clinicHistory', event.target.value)}
              multiline
              rows={4}
              value={(patients && patients[index]?._clinicHistory) || ''}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

        </Grid>
      ))}
      
      <Typography variant="caption" component="span">{t('formMatchingDisclosure1')}</Typography>
      <Typography variant="caption" component="span">{t('formMatchingDisclosure2')}</Typography>
    </Grid>
  )
}
